import { Card, Typography, Box } from "@mui/material";

export default function KPICard({
  label,
  value
}: {
  label: string;
  value: string;
}) {
  return (
    <Card
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "16px",
        border: "1px solid #eee"
      }}
    >
      <Typography color="text.secondary" fontSize="13px">
        {label}
      </Typography>

      <Box mt={1}>
        <Typography fontSize="22px" fontWeight={600}>
          {value}
        </Typography>
      </Box>
    </Card>
  );
}
